import { ReactNode } from 'react';
import { Box, BoxProps } from '@mantine/core';
import { LAYOUT_WIDTH } from '../constants/layout';

export type PageWidth = 'default' | 'list' | 'detail' | 'wide' | 'auth';

interface PageContainerProps extends Omit<BoxProps, 'style'> {
  children: ReactNode;
  width?: PageWidth;
  noPadding?: boolean;
}

const WIDTH_MAP: Record<PageWidth, number> = {
  default: LAYOUT_WIDTH.DEFAULT,
  list: LAYOUT_WIDTH.LIST,
  detail: LAYOUT_WIDTH.DETAIL,
  wide: LAYOUT_WIDTH.WIDE,
  auth: LAYOUT_WIDTH.AUTH,
};

export function PageContainer({ 
  children, 
  width = 'default',
  noPadding = false,
  ...props 
}: PageContainerProps) {
  return (
    <Box
      style={{
        maxWidth: WIDTH_MAP[width],
        margin: '0 auto',
        width: '100%',
        minWidth: 0,
      }}
      p={noPadding ? 0 : 'md'}
      {...props}
    >
      {children}
    </Box>
  );
}

export default PageContainer;
